import React from 'react';
export function UrgencyBar() {
  return <div className="bg-brand-pink text-brand-black py-2 px-4 text-center text-xs md:text-sm font-semibold tracking-wide flex items-center justify-center gap-2 z-50 relative" data-id="element-167">
      <span className="relative flex h-2 w-2" data-id="element-168">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-black opacity-75" data-id="element-169"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-black" data-id="element-170"></span>
      </span>
      ⚡ OFERTA POR TIEMPO LIMITADO — ACCESO INSTANTÁNEO
    </div>;
}